export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-amber-500 via-orange-500 to-amber-600 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Columna 1: Logo y descripción */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
                <i className="ri-hammer-fill text-2xl text-amber-600"></i>
              </div>
              <span className="text-xl font-bold">Marin Construesfuerzo</span>
            </div>
            <p className="text-white/90 text-sm leading-relaxed">
              Empresa líder en <strong>construcción general en Lanzarote</strong>, especializada en <strong>reformas integrales</strong>, <strong>pintura profesional</strong> y servicios de <strong>fontanería y electricidad en Arrecife</strong>.
            </p>
          </div>

          {/* Columna 2: Enlaces rápidos */}
          <div>
            <h4 className="font-bold text-lg mb-4">
              <a href="#enlaces-rapidos" className="hover:text-white/80 transition-colors">Enlaces Rápidos</a>
            </h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#inicio" className="hover:text-white/80 transition-colors">Inicio</a></li>
              <li><a href="#servicios" className="hover:text-white/80 transition-colors">Servicios</a></li>
              <li><a href="#proyectos" className="hover:text-white/80 transition-colors">Proyectos</a></li>
              <li><a href="#sobre-nosotros" className="hover:text-white/80 transition-colors">Sobre Nosotros</a></li>
              <li><a href="#contacto" className="hover:text-white/80 transition-colors">Contacto</a></li>
              <li><a href="/politica-de-privacidad" className="hover:text-white/80 transition-colors">Política de Privacidad</a></li>
              <li><a href="/aviso-legal" className="hover:text-white/80 transition-colors">Aviso Legal</a></li>
              <li><a href="/politica-de-cookies" className="hover:text-white/80 transition-colors">Política de Cookies</a></li>
            </ul>
          </div>

          {/* Columna 3: Servicios */}
          <div>
            <h4 className="font-bold text-lg mb-4">
              <a href="#servicios" className="hover:text-white/80 transition-colors">Nuestros Servicios</a>
            </h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#servicios" className="hover:text-white/80 transition-colors">Construcción General</a></li>
              <li><a href="#servicios" className="hover:text-white/80 transition-colors">Reformas Integrales</a></li>
              <li><a href="#servicios" className="hover:text-white/80 transition-colors">Pintura Profesional</a></li>
              <li><a href="#servicios" className="hover:text-white/80 transition-colors">Fontanería</a></li>
              <li><a href="#servicios" className="hover:text-white/80 transition-colors">Electricidad</a></li>
              <li><a href="#servicios" className="hover:text-white/80 transition-colors">Mantenimiento</a></li>
            </ul>
          </div>

          {/* Columna 4: Contacto */}
          <div>
            <h4 className="font-bold text-lg mb-4">
              <a href="#informacion-contacto" className="hover:text-white/80 transition-colors">Contacto</a>
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-lg mt-0.5"></i>
                <span>CL Victor Hugo, 91, 35500 Arrecife, Las Palmas, Lanzarote</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-phone-line text-lg"></i>
                <a href="tel:+34613725305" className="hover:text-white/80 transition-colors">613 72 53 05</a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-mail-line text-lg"></i>
                <a href="mailto:m.construesfuerzo@gmail.com" className="hover:text-white/80 transition-colors">m.construesfuerzo@gmail.com</a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-time-line text-lg"></i>
                <span>Lun - Vie: 8:00 - 18:00</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Línea divisoria */}
        <div className="border-t border-white/20 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-white/80">
              © 2025 Marin Construesfuerzo. Todos los derechos reservados.
            </p>
            <div className="flex items-center space-x-4">
              <a href="https://facebook.com" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://www.instagram.com/m.construesfuerzo" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="https://readdy.ai/?ref=logo" className="text-sm text-white/70 hover:text-white/90 transition-colors whitespace-nowrap">Website Builder</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}